export enum UserThemeStatusEnum {
  InProgress = 'in_progress',
  Completed = 'completed',
}
